import Error500 from './Error500';

$(document).ready(function() {
    let error500 = Error500();
    error500.init();
});
